__turbopack_context__.v({
  "externalLink": "renderers-module__8jGKYa__externalLink",
  "internalLink": "renderers-module__8jGKYa__internalLink",
  "paragraph": "renderers-module__8jGKYa__paragraph",
  "scrollview": "renderers-module__8jGKYa__scrollview",
});
